import { connect } from 'react-redux';
import { selectAnnotatedPageNumbers } from '../selectors/annotation.selectors';
import { AppState } from '../../app-state';
import { PageControls } from '../../common/components/page-controls.component';
import {
  decrementPage,
  incrementPage,
  setPage,
} from '../../documents/actions/page-controls.actions';
import {
  selectPageByViewOrDefault,
  selectPageCount,
} from '../../documents/selectors/page-controls.selectors';
import { PageView } from '../../documents/models/page-view.model';

const PAGE_VIEW = PageView.Text;

function findPrevAnnotatedPage(
  current: number,
  pages: number[],
): number | null {
  for (let i = pages.length - 1; i >= 0; i--) {
    if (pages[i] < current) return pages[i];
  }
  return null;
}

function findNextAnnotatedPage(
  current: number,
  pages: number[],
): number | null {
  for (const p of pages) {
    if (p > current) return p;
  }
  return null;
}

export const AnnotationViewerPageControls = connect(
  (state: AppState) => {
    const currentPage = selectPageByViewOrDefault(PAGE_VIEW, state);
    const annotatedPages = selectAnnotatedPageNumbers(state);
    return {
      currentPage,
      numberPages: selectPageCount(state),
      prevAnnotatedPage: findPrevAnnotatedPage(currentPage, annotatedPages),
      nextAnnotatedPage: findNextAnnotatedPage(currentPage, annotatedPages),
    };
  },
  dispatch => ({
    incrementClicked: () => {
      dispatch(incrementPage(PAGE_VIEW));
    },
    decrementClicked: () => {
      dispatch(decrementPage(PAGE_VIEW));
    },
    gotoPage: (page: number) => {
      dispatch(setPage(PAGE_VIEW, page));
    },
  }),
)(PageControls);
